(function() {
    let galleryItems;

    window.addEventListener("load", (event) => {
        galleryItems = document.querySelectorAll(".teaser-gallery__item");

        createObserver();
    }, false);

    function createObserver() {
        let observer;

        let options = {
            root: null,
            rootMargin: "0px",
            threshold: 0
        };

        if ('IntersectionObserver' in window) {
            observer = new IntersectionObserver(handleIntersect, options);
            galleryItems.forEach(element => {
                observer.observe(element);
            });
        } else {
            galleryItems.forEach(element => {
                element.classList.add("visible");
            })
        }
    }

    function handleIntersect(entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add("visible");
            }
        });
    }
})();